import { Experience, Research, Education, Extracurricular, TechnicalSkills } from '../types/cv.types';

export const experiences: Experience[] = [
    {
        title: "E-Commerce Manager",
        company: "Dronefactory.ch",
        location: "St. Gallen, CH",
        period: "July 2017 - Present",
        points: [
            "Website Management: Use WordPress and Stripe",
            "Product Management: Monitor prices, descriptions etc.",
            "Technical Support: Assist customer with component selection and electronics"
        ]
    },
    {
        title: "Internship - Rotational Program",
        company: "LGT Bank",
        location: "Hong Kong, HKG",
        period: "Feb. 2020 - July 2020",
        points: [
            "IT: Maintain intranet content, contribute to business contingency infrastructure, and assist with digitalisation projects",
            "Marketing: Update brand identity guidelines, scout event locations, and review marketing material",
            "KYC: Perform periodic reviews and client on-boarding",
            "Investment Services: Macro-outlook presentations, Fundamentals Analysis, and Financial Derivatives",
            "Management Office: Hands on experience in project management"
        ]
    },
    {
        title: "Internship - KYC",
        company: "LGT Bank",
        location: "Hong Kong, HKG",
        period: "Aug. 2021 - Nov. 2021",
        points: [
            "Periodic KYC reviews: Name screening, Risk classification",
            "Client on-boarding: Document checks"
        ]
    }
];

export const research: Research[] = [
    {
        title: "Student Researcher",
        organization: "Center for Aviation and Space Competence - University of St. Gallen",
        location: "St. Gallen",
        period: "Sep. 2023 - July 2024",
        points: [
            "Quantify impact of student-led satellite missions on new space economy"
        ]
    },
    {
        title: "Student Researcher",
        organization: "Institute for Computer Science - University of St. Gallen",
        location: "St. Gallen",
        period: "July 2024 - November 2024",
        points: [
            "Build and evaluate sustainable routing algorithms",
            "Develop web application for benchmarking of routing algorithms (React, Flask, Mapbox, OSMnx)"
        ]
    }
];

export const education: Education[] = [
    {
        degree: "Bachelor of Science in Computer Science",
        school: "University of St. Gallen",
        location: "St. Gallen, CH",
        period: "Sep. 2022 - Present"
    },
    {
        degree: "German International Abitur",
        school: "German Swiss International School",
        location: "Hong Kong, HKG",
        period: "Aug. 2017 - May 2019",
        points: ["Head of the Student Council"]
    }
];

export const extracurricular: Extracurricular[] = [
    {
        title: "Systems Engineer SAGE CubeSat",
        organization: "ARIS Space",
        location: "Zurich, CH",
        period: "June 2023 - Present",
        points: [
            "Leadership skills: Manage subteams, organise workshops, foster collaboration and team work",
            "Technical skills: Spacecraft systems configuration, interface definition, testing, system architecture design, and software development"
        ]
    },
    {
        title: "EPS Team Member SAGE CubeSat",
        organization: "ARIS Space",
        location: "Zurich, CH",
        period: "March 2023 - June 2023",
        points: [
            "Technical skills: Development of FlatSat testing infrastructure"
        ]
    },
    {
        title: "Private Pilots Licence | PPL(A), SEP rating",
        period: "April 2022 - Nov. 2022",
        points: [
            "Understanding of aerodynamics and flight mechanics",
            "Knowledge in various related fields such as air law, weather, and aircraft systems"
        ]
    }
];

export const technicalSkills: TechnicalSkills = {
    languages: ['TypeScript', 'Java', 'Python', 'SQL (Postgres)'],
    frameworks: ['React', 'WordPress', 'SpringBoot', 'Linux', 'LaTeX', 'MS Office'],
    developerTools: ['Git', 'Docker']
}; 